import * as React from 'react';
import './index.scss';
import { Table } from 'antd';
import { requestStatistics, requestList2, checkToken } from '../../model/api';
import dateFormat from 'dateformat';
import {parse} from 'query-string';

export default class Statistics extends React.Component {
  _weekday= ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
  _selectText = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  _deadTime = [0, 9.5*60*60*1000, 17.5*60*60*1000];
  _locations = {
    '1': ["7层东侧茶水间", "8层西侧吧台", "9层东侧吧台", "10层西侧吧台", "11层东侧吧台", "东升大厦"],
    'keg': ["7层东侧茶水间", "8层西侧吧台", "9层东侧吧台", "10层西侧吧台", "11层东侧吧台", "东升大厦"],
    'default': ["7层东侧茶水间", "8层西侧吧台", "9层东侧吧台", "10层西侧吧台", "11层东侧吧台", "东升大厦"]
  }
  _date = null

  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      tab: 0,
      now: new Date(), 
      company: "1",
      showList: false,
      lists: [],
      group: ""
    }

    this.update = this.update.bind(this);
    this.requestList = this.requestList.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.stuffList = this.stuffList.bind(this);
  }

  async componentDidMount() {
    // await this.tokenAuth()
    let parsed = parse(window.location.search);
    if(parsed.date) {
      this._date = parsed.date;
    }
    if(parsed.ckey) {
      this.setState({company: parsed.ckey}, () => this.update());
    }else {
      this.update();
    }
    if(parsed.group) {
      this.setState({group: parsed.group});
    }
    if(parsed.showList) {
      this.setState({showList: true});
    }
  }

  // async tokenAuth() {
  //   const isValid = await checkToken()
  //   // 如果未登录跳到登录
  //   if (!isValid) {
  //     this.props.history.push(`/login?redirect=${encodeURIComponent('/statistics')}`)
  //   }
  // }

  update() {
    this.setState({now: new Date()});
    if(this._date) {
      let date = this._date;
      requestStatistics(date, this.state.company).then(data => {
        if(data.code == 0) {
          if(data.data) {
            this.setState({datas: [data.data]});
          }
        }
      })
    }else {
      let date = dateFormat(new Date(), 'yyyy-mm-dd');
      requestStatistics(date, this.state.company).then(data => {
        if(data.code == 0) {
          if(data.data) {
            this.setState({datas: [data.data]});
            let date = new Date(data.data.date + "T00:00:00.000+08:00");
            let nextDate = dateFormat(new Date(date.getTime() + 24*60*60*1000), "yyyy-mm-dd");
            requestStatistics(nextDate, this.state.company).then(data2 => {
              if(data2.code == 0 && data2.data) {
                this.setState({datas: [data.data, data2.data]});
                if(this.state.showList) {
                  this.requestList(data.data.date)
                }
              }
            })
          }
        }
      })
    }
    
  }

  requestList(date) {
    requestList2(date, this.state.company).then(data => {
      if(data.code == 0) {
        if(data.data) {
          this.setState({lists: [data.data.list]});
          let datedate = new Date(date + "T00:00:00.000+08:00");
          let nextDate = dateFormat(new Date(datedate.getTime() + 24*60*60*1000), "yyyy-mm-dd");
          requestList2(nextDate, this.state.company).then(data2 => {
            if(data2.code == 0 && data2.data) {
              this.setState({lists: [data.data.list, data2.data.list]});
            }
          })
        }
      }
    })
  }

  getDeadText(index) {
    let datas = this.state.datas;
    let data = datas && this.state.tab <= datas.length-1 ? datas[this.state.tab] : null;
    if(data) {
      let date = new Date(data.date + "T00:00:00.000+08:00");
      if(date.getTime() + this._deadTime[index] >= this.state.now.getTime()) {
        return <span style={{color: 'lime', marginLeft: '12px'}}>预定中</span>
      }else {
        return <span style={{color: 'red', marginLeft: '12px'}}>预定已结束</span>
      }
    }else {
      return undefined;
    }
  }

  getColumns() {
    return [
      { 
        title: "选项",
        dataIndex: "selected",
        key: "selected"
      },...(this._locations[this.state.company] || this._locations['default']).map((d, i) => ({ 
        title: d,
        dataIndex: `location_${i}`,
        key: `location_${i}`
      })),{ 
        title: "合计",
        dataIndex: "total",
        key: "total"
      }
    ]
  }

  fixLocationBug(index) {
    if(index == "赛尔五楼") {
      return 1;
    }else if(index == "赛尔二楼") {
      return 0;
    }else if (index == "同方大厦") {
      return 2;
    }
    return index;
  }

  stuffList(data) {
    return (
      <div>
        {
          this._locations[this.state.company].map((value, index) => {
            return (
              <div key={index}>
                {value}
                <div>
                  {data.filter(d => d.location == index).sort((a, b) => a.select - b.select).map((stuff) => {
                    return `${stuff.name}(${this._selectText[stuff.select]})`
                  }).join(", ")}
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  render() {
    const { lists, showList } = this.state;
    let datas = this.state.datas;
    let list = lists && lists.length - 1 >= this.state.tab ? lists[this.state.tab] : {};
    let data = datas && this.state.tab <= datas.length-1 ? datas[this.state.tab] : null;

    let breakfast = [];
    let lunch = [];
    let dinner = [];

    if(data && data.list) {
      let b_max = Math.max(...data.list.map(d => d[0].selected));
      let l_max = Math.max(...data.list.map(d => d[1].selected));
      let d_max = Math.max(...data.list.map(d => d[2].selected));
      breakfast = Array(Math.max(0, b_max+1)).fill(0).map((_, i) => {return {key: `b_${i}`, selected: this._selectText[i], location_0: 0, location_1: 0, location_2: 0, location_3: 0, location_4: 0, location_5: 0, total: 0}});
      lunch = Array(Math.max(0, l_max+1)).fill(0).map((_, i) => {return {key: `l_${i}`, selected: this._selectText[i], location_0: 0, location_1: 0, location_2: 0, location_3: 0, location_4: 0, location_5: 0, total: 0}});
      dinner = Array(Math.max(0, d_max+1)).fill(0).map((_, i) => {return {key: `d_${i}`, selected: this._selectText[i], location_0: 0, location_1: 0, location_2: 0, location_3: 0, location_4: 0, location_5: 0, total: 0}});
      data.list.forEach(d => {
        if(d[0].selected >= 0) {
          breakfast[d[0].selected][`location_${this.fixLocationBug(d[0].location)}`] += 1;
          breakfast[d[0].selected].total += 1;
        }
        if(d[1].selected >= 0) {
          if(lunch[d[1].selected]) {
            lunch[d[1].selected][`location_${this.fixLocationBug(d[1].location)}`] += 1;
            lunch[d[1].selected].total += 1;
          }
        }
        if(d[2].selected >= 0) {
          dinner[d[2].selected][`location_${this.fixLocationBug(d[2].location)}`] += 1;
          dinner[d[2].selected].total += 1;
        }
      })
    }

    return (
      <div className='statistics'>
        <div className='st-header'>
          <div className='st-header-back' onClick={() => this.props.history.goBack()}>{"< 返回"}</div>
        </div>
        <div className='st-title'>{`统计信息`}</div>
        <div className='st-update' onClick={this.update}>刷新</div>
        { 
          !!datas.length && (
            <div className='st-tabs'>
              {datas.map((d, i) => {
                let curDate = new Date(d.date + "T00:00:00.000+08:00");
                return (
                  <div className='st-tab' onClick={() => i != this.state.tab && this.setState({tab: i})} style={i == this.state.tab ? {color: "#0095ff", fontWeight: 'bold'} : undefined} key={i}>{dateFormat(curDate, "yyyy-mm-dd ") + this._weekday[curDate.getDay()]}</div>
                )
              })}
            </div>
          )
        }
        <div className='st-dinner'>
        <div className='st-dinner-title'>早餐<span>{` 共 ${Object.keys(breakfast).reduce((total, d) => total + breakfast[d].location_0 + breakfast[d].location_1 + breakfast[d].location_2 + breakfast[d].location_3 + breakfast[d].location_4, 0)} 份`}</span>{this.getDeadText(0)}</div>
          <Table dataSource={breakfast} columns={this.getColumns()} size='small' pagination={false} />
          {showList && (
            <div className='st-list'>
              <div>订餐人员名单:</div>
              <div>{list.breakfast && this.stuffList(list.breakfast)}</div>
            </div>
          )}
        </div>
        <div className='st-dinner'>
          <div className='st-dinner-title'>午餐<span>{` 共 ${Object.keys(lunch).reduce((total, d) => total + lunch[d].location_0 + lunch[d].location_1 + lunch[d].location_2 + lunch[d].location_3 + lunch[d].location_4, 0)} 份`}</span>{this.getDeadText(1)}</div>
          <Table dataSource={lunch} columns={this.getColumns()} size='small' pagination={false} />
          {showList && (
            <div className='st-list'>
              <div>订餐人员名单:</div>
              <div>{list.lunch && this.stuffList(list.lunch)}</div>
            </div>
          )}
        </div>
        <div className='st-dinner'>
          <div className='st-dinner-title'>晚餐<span>{` 共 ${Object.keys(dinner).reduce((total, d) => total + dinner[d].location_0 + dinner[d].location_1 + dinner[d].location_2 + dinner[d].location_3 + dinner[d].location_4, 0)} 份`}</span>{this.getDeadText(2)}</div>
          <Table dataSource={dinner} columns={this.getColumns()} size='small' pagination={false} />
          {showList && (
            <div className='st-list'>
              <div>订餐人员名单:</div>
              <div>{list.dinner && this.stuffList(list.dinner)}</div>
            </div>
          )}
        </div>
      </div>
    )
  }
}